<template>
  <Modal :value="open" :onClose="close" :close="false">
    <b-row class="form-group">
      <b-col class="busca" md="6">
        <Input
          ref="descricao"
          label="Descrição"
          id="descricao"
          @keypress.enter.prevent="save"
          labelBold
          v-model="valueProduto.descricao"
        />
      </b-col>
      <b-col>
        <b-form-group label="Quantidade" label-for="quantidade">
          <money
            :disabled="valueProduto.lote"
            class="form-control"
            id="quantidade"
            name="quantidade"
            v-model="valueProduto.quantidade"
            v-bind="quantityOptions"
          />
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="Valor Unitário" label-for="preco">
          <money
            class="form-control"
            id="preco"
            name="preco"
            v-model="valueProduto.preco"
            v-bind="priceOptions"
          />
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="Desconto" label-for="desconto">
          <b-input-group>
            <money
              v-if="descontoTipo === 'valor'"
              :key="'desconto-valor-' + descontoInputKey"
              class="form-control"
              id="desconto"
              name="desconto"
              v-model="valueProduto.desconto"
              v-bind="configMask"
            />
            <b-form-input
              v-else
              :key="'desconto-percentual-' + descontoInputKey"
              id="desconto"
              name="desconto"
              type="number"
              min="0"
              max="100"
              step="0.01"
              v-model.number="valueProduto.desconto"
            />
            <b-input-group-append>
              <b-button variant="light" @click="toggleDescontoTipo">
                {{ descontoTipo === "valor" ? "R$" : "%" }}
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="4">
        <b-form-group label="Total de Item R$" label-for="total">
          <money
            class="form-control"
            id="total"
            name="total"
            disabled
            v-model="totalProduto"
            v-bind="priceOptions"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group id="observacao" label="Observação" label-for="observacao">
          <b-form-textarea
            id="observacao"
            name="observacao"
            placeholder=""
            v-model="valueProduto.informacoesAdicionais"
          >
          </b-form-textarea>
        </b-form-group>
      </b-col>
    </b-row>
    <div class="confirm-buttons">
      <Button type="error" @click="close()">Fechar</Button>
      <Button
        type="success"
        @click="
          () => {
            save();
            close();
          }
        "
        >Gravar</Button
      >
    </div>
  </Modal>
</template>

<script>
import { Modal } from "@/components";
import { Button, Input } from "@/components/Form";
import { Money } from "v-money";
import { MONEY as settingMoney, quantityOptions, priceOptions } from "@/modules/Application";
import { SistemaMixin } from "@/modules/Application";
import FormatMixin from "@/modules/Application/mixins/FormatMixin";
import PessoaMixin from "@/modules/Application/mixins/PessoaMixin";

export default {
  name: "ModalProduto",
  mixins: [FormatMixin, PessoaMixin, SistemaMixin],
  components: {
    Modal,
    Button,
    Input,
    Money,
  },
  data() {
    return {
      valueProduto: {},
      configMask: settingMoney,
      quantityOptions,
      priceOptions,
      descontoTipo: "valor",
      descontoInputKey: 0,
    };
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    close: {
      type: Function,
      required: true,
    },
    changeProduto: {
      type: Function,
      required: true,
    },
    produto: {
      type: Object,
      required: true,
    },
  },
  watch: {
    produto(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.valueProduto = newValue;
      }
    },
  },
  mounted() {
    this.valueProduto = this.produto;
    this.getDataInit();
  },
  methods: {
    toggleDescontoTipo() {
      this.descontoTipo =
        this.descontoTipo === "valor" ? "percentual" : "valor";
      this.valueProduto.desconto = 0;
      this.descontoInputKey++;
    },
    getDescontoProdutoEmReais() {
      const desconto = parseFloat(this.valueProduto.desconto) || 0;
      const subtotal =
        (this.formatNumberToFloat(this.valueProduto.quantidade || 0) || 0) *
        (this.formatNumberToFloat(this.valueProduto.preco || 0) || 0);

      if (this.descontoTipo === "percentual") {
        return (subtotal * desconto) / 100;
      }

      return desconto;
    },
    save() {
      this.valueProduto = {
        ...this.valueProduto,
        desconto: this.getDescontoProdutoEmReais(),
      };
      this.changeProduto(this.valueProduto);
      this.$toast.success("Produto editado com sucesso!");
    },
    async getDataInit() {},
    setProduto(produto) {
      this.valueProduto = produto;
    },
  },
  computed: {
    totalProduto() {
      return (
        (this.formatNumberToFloat(this.valueProduto.quantidade || 0) || 0) *
          (this.formatNumberToFloat(this.valueProduto.preco || 0) || 0) -
        this.getDescontoProdutoEmReais()
      );
    },
  },
};
</script>
